module.exports = __webpack_public_path__ + "images/cc.d906fe5c1274c56c5571.png";